import React from 'react';
import { TeslaText as Text, ChevronIcon } from 'components';

import * as styles from './styles.module.scss';

const AccordionItem = ({ title, body, index, isOpen, onToggle }) => (
  <div className={styles.accordionItem}>
    <button type="button" className={styles.accordionHeader} onClick={() => onToggle(index)}>
      <Text className={styles.accordionTitle} html={title?.html} text={title?.text} />
      <ChevronIcon className={`${styles.chevron} ${isOpen ? styles.open : ''}`} />
    </button>
    <div className={`${styles.accordionBodyWrapper} ${isOpen ? styles.accordionBodyOpen : ''}`}>
      <div className={styles.accordionBodyInner}>
        <Text className={styles.accordionBody} html={body?.html} text={body?.text} />
      </div>
    </div>
  </div>
);

export default AccordionItem;
